export default __webpack_public_path__ + "static/media/thumbtack.0e06eaf5.svg";